import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// por último: a escala de espaçamento vale sobre o CSS de cada tela
import './design/ritmo.css';
import './design/tokens.css';
import './design/confete.css';
import './design/tabelas.css';
import { ordenarTabelasDoApp } from './design/ordenar-tabelas';
import { rotularTabelasDoApp } from './design/rotulos-de-tabela';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Elemento #root não encontrado em index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// tabela no celular vira cartão: cada valor ganha o nome da coluna (design/tabelas.css)
rotularTabelasDoApp();

// qualquer tabela ordena clicando no título da coluna (design/ordenar-tabelas.ts)
ordenarTabelasDoApp();

// Instalar como app no celular: só em produção (no dev o service worker atrapalharia o recarregar).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
